// @flow

import './index.scss';
import * as React from 'react';
import { Range as BaseRange } from 'react-range';
import ThumbLabel from './ThumbLabel';
import Track from './Track';
import Thumb from './Thumb';
import formatAmount from 'utils/formatAmount';

export type Values = number[];

type Props = {|
    min: number,
    max: number,
    defaultValues: Values,
    onChange: (values: Values) => mixed
|};

const Range = ({ min, max, defaultValues, onChange }: Props): React.Node => {
    const rangeRef: any = React.useRef();

    const [values, setValues] = React.useState<Values>(defaultValues);

    const handlePricesChange = React.useCallback(
        (newValues: Values) => { setValues(newValues); },
        []
    );

    return (
        <div className="Range">
            <BaseRange
                ref={rangeRef}
                step={1000}
                min={min}
                max={max}
                values={values}
                onChange={handlePricesChange}
                onFinalChange={onChange}
                renderTrack={({ props, children }: any) => (
                    <Track props={props} values={values}>{children}</Track>
                )}
                renderThumb={({ props, index, isDragged }: any) => (
                    <Thumb
                        key={index}
                        props={props}
                        isDragged={isDragged}
                    >
                        <ThumbLabel
                            rangeRef={rangeRef.current}
                            values={values}
                            index={index}
                            max={max}
                        />
                    </Thumb>
                )}
            />
            <div className="Range__labels">
                <span>{formatAmount(min, { decimal: 0, currency: '' })}</span>
                <span>{formatAmount(max, { decimal: 0, currency: '+' })}</span>
            </div>
        </div>
    );
};

export default Range;
